import { fmtChange, fmtNumber } from './format';
import { c, card, chart } from '../../theme';

// How many customers' bills move by how much. Each band is a button that
// narrows the customer list to it; clicking the selected band again clears it.
// Length is the message, so every band is one hue except the two that change
// the conversation: bills that go DOWN (a credit scaled with its charge), and
// $250+ a month, which is the list worth calling before the change lands.
export default function IncreaseBands({ bands, selected, onSelect }) {
  const max = Math.max(1, ...bands.map((b) => b.accounts));
  const big = bands.filter((b) => b.key === '250to1000' || b.key === 'gte1000').reduce((n, b) => n + b.accounts, 0);

  return (
    <section style={s.card} aria-label="How much each customer's bill changes">
      <div style={s.head}>
        <span style={s.title}>How much each customer&apos;s monthly bill changes</span>
        <span style={s.hint}>Click a band to list those customers</span>
      </div>
      <div style={s.bands}>
        {bands.map((b) => {
          const on = selected === b.key;
          const tone = b.key === 'down' ? chart.coVisible[3] : b.key === 'none' ? chart.other
            : (b.key === '250to1000' || b.key === 'gte1000') ? chart.coVisible[1] : chart.coVisible[0];
          return (
            <button key={b.key} type="button" onClick={() => onSelect(b.key)} aria-pressed={on}
                    style={{ ...s.band, ...(on ? s.bandOn : null) }}>
              <span style={s.bandLabel}>{b.label}</span>
              <span style={s.track}>
                <span style={{ ...s.fill, background: tone, width: `${b.accounts ? Math.max(0.8, (100 * b.accounts) / max) : 0}%` }} />
              </span>
              <span style={s.count}>{fmtNumber(b.accounts)}</span>
              <span style={s.sum}>{b.accounts ? fmtChange(b.change) + '/mo' : ''}</span>
            </button>
          );
        })}
      </div>
      {big > 0 && (
        <div style={s.foot}>{fmtNumber(big)} customer{big === 1 ? '' : 's'} go up $250 or more a month.</div>
      )}
    </section>
  );
}

const s = {
  card:  { ...card.sm, padding: '12px 14px' },
  head:  { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '8px' },
  title: { fontSize: '13px', fontWeight: 600, color: c.text },
  hint:  { fontSize: '11px', color: c.textFaint },
  bands: { display: 'flex', flexDirection: 'column', gap: '2px' },
  band:  { display: 'grid', gridTemplateColumns: '96px minmax(0, 1fr) 70px 120px', alignItems: 'center', gap: '10px', width: '100%', padding: '4px 6px', borderWidth: '1px', borderStyle: 'solid', borderColor: 'transparent', borderRadius: '6px', background: 'none', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left' },
  bandOn:{ background: c.infoTint, borderColor: '#BFDBFE' },
  bandLabel: { fontSize: '12.5px', color: c.textStrong },
  track: { display: 'block', height: '14px', background: chart.grid, borderRadius: '4px', overflow: 'hidden' },
  fill:  { display: 'block', height: '14px', borderRadius: '4px' },
  count: { fontSize: '12.5px', fontWeight: 600, color: c.text, textAlign: 'right', fontVariantNumeric: 'tabular-nums' },
  sum:   { fontSize: '11.5px', color: c.textMuted, textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
  foot:  { fontSize: '11.5px', color: c.textMuted, borderTop: `1px solid ${c.border}`, marginTop: '8px', paddingTop: '8px' },
};
